document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll("video");

  videos.forEach((video) => {
    if (video.closest(".wt-product__gallery")) {
      let controlsTimeout;
      let hasInteracted = false;

      video.removeAttribute("controls");

      const showControlsTemporarily = () => {
        video.setAttribute("controls", "");

        clearTimeout(controlsTimeout);

        controlsTimeout = setTimeout(() => {
          video.removeAttribute("controls");
          video.blur();
        }, 1500);
      };

      video.addEventListener("click", () => {
        console.log("user interaction");
        hasInteracted = true;
        showControlsTemporarily();
      });

      const handlePlayOrPause = () => {
        setTimeout(() => {
          video.blur();

          if (hasInteracted) {
            showControlsTemporarily();
          }
        }, 50);
      };

      video.addEventListener("pause", handlePlayOrPause);
      video.addEventListener("play", handlePlayOrPause);
    }
  });
});
